import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
@Component({
  selector: 'app-delete-account-modal',
  templateUrl: './delete-account-modal.component.html',
  styleUrls: ['./delete-account-modal.component.scss']
})
export class DeleteAccountModalComponent implements OnInit, OnDestroy  {
  language: any;
  hasError: boolean;
  ErrorMessage: string;
  private unsubscribe: Subscription[] = [];
  isLoading$: Observable<boolean>;
  @Input() PatientId
  constructor(private translationService: TranslationService, private authService: AuthService,
    private toast: HotToastService,
   public modal: NgbActiveModal) { this.isLoading$ = this.authService.isLoading$; }
  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
  }
  onNoClick(): void {
    this.modal.close();
  }
  DeleteAccount() {
    this.authService.showLoader();
    const Subscr = this.authService.DeleteAccount().pipe(
      catchError((errorMessage) => {
        return of(errorMessage);
      })
    ).subscribe(res => {
      if (res.isSuccess && res.responseCode == 200) {
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
        this.onNoClick();
        this.authService.logout();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.authService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "رقم الهوية أو كلمة المرور غير صحيحة";
        }
        else {
          this.ErrorMessage = "National ID / Iqama or Password is incorrect";
        }
        this.authService.hideLoader();

      }
    });
    this.unsubscribe.push(Subscr);
  }
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
